// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftGeocodingStatus_decode($$enum) {
  if ($$enum === "NotCalled" || $$enum === "ErrorOutsideChapterBoundaries" || $$enum === "Called" || $$enum === "ErrorDuplicateListing" || $$enum === "Valid" || $$enum === "Error") {
    return $$enum;
  }
}

let localDraftGeocodingStatus_fromString = localDraftGeocodingStatus_decode;

let Utils = {
  localDraftGeocodingStatus_decode: localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: localDraftGeocodingStatus_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalDraftDisplayNeighborhood",
          "kind": "LinkedField",
          "name": "displayNeighborhoods",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "geocodingStatus",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
